/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSessionAndMessages} from '../api'

 export const useQueryGetSessionAndMessages = createReactQueryHook('getSessionAndMessages', getSessionAndMessages)
